import React, { Fragment, useCallback, useState } from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';

import { Button } from 'antd';

import InstallmentCashbackAlert from 'v2/components/Pages/FinancialStatement/CardList/AnticipationCard/InstallmentCashbackAlert';
import type { IBankAccount } from 'v2/interfaces/financial';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  value: number;
  bankAccount: IBankAccount;
}

const ConfirmTransactionMessage = ({ value, bankAccount }: IProps) => {
  const [showBankAccount, setShowBankAccount] = useState(false);

  const handleShowBankAccount = useCallback(() => setShowBankAccount(!showBankAccount), [showBankAccount]);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const currency = user?.crossborder ? 'USD' : 'BRL';

  const hideNumber = (value: string) => {
    if (showBankAccount) return value;

    return value.replace(/[0-9]/g, '*');
  };

  return (
    <Fragment>
      <div>
        <p className='mb-0! text-center'>
          Você solicitou uma transferência no valor de{' '}
          <b>
            <FormattedNumber value={value} format={currency} />
          </b>
          .
          <br />
          Neste valor, serão descontados os encargos de transferência no valor de R$ 9,00. Então o valor total
          transferido para sua conta será de{' '}
          <b>
            <FormattedNumber value={value - 9} format={currency} />
          </b>
          .
          <br />O valor será transferido para sua conta bancária:
        </p>

        <div className='flex items-center justify-center'>
          <div>
            Agência: {hideNumber(bankAccount.agency)}-{hideNumber(bankAccount.agency_digit)} Conta:{' '}
            {hideNumber(bankAccount.account)}-{hideNumber(bankAccount.account_digit)}
          </div>
          <Button type='text' icon={<Icon.Eye />} onClick={handleShowBankAccount} />
        </div>
        <div className='mt-2' />

        <p className='mb-0! text-center'>
          <b>Deseja continuar com a transação?</b>
        </p>
      </div>

      <div className='mt-4' />

      <p className='mb-0! text-center text-xs'>
        * Caso possua antecipações, o recebimento antes do prazo incorre em taxa administrativa de 2,99% + 0,1% por dia
        antecipado
      </p>

      <div className='mt-3 text-left'>
        <InstallmentCashbackAlert enabled />
      </div>
    </Fragment>
  );
};

export default ConfirmTransactionMessage;
